import { Injectable } from '@angular/core';
import { RequestService } from 'src/app/core/service/request.service';

@Injectable({
  providedIn: 'root',
})
export class SaRaService {
  constructor(private restApi: RequestService) {}
  getRaTemplate(id) {
    return this.restApi.get(`/api/v5/sa-ra-templates/${id}`);
  }

  getLikelihood(tid) {
    return this.restApi.get(`/api/v5/sa-ra-likelihood-ratings`, {
      'templateId.equals': tid,
    });
  }
  addLikeliHood(data) {
    return this.restApi.request(
      'POST',
      '/api/v5/sa-ra-likelihood-ratings',
      data
    );
  }
  updateLikeliHood(id, data) {
    return this.restApi.request(
      'PUT',
      `/api/v5/sa-ra-likelihood-ratings/${id}`,
      data
    );
  }
  deleteLikeliHood(id) {
    return this.restApi.request(
      'DELETE',
      `/api/v5/sa-ra-likelihood-ratings/${id}`
    );
  }

  getImpactRating(tid) {
    return this.restApi.get(`/api/v5/sa-ra-impact-ratings`, {
      'templateId.equals': tid,
    });
  }
  addImpactRating(data) {
    return this.restApi.request('POST', '/api/v5/sa-ra-impact-ratings', data);
  }
  updateImpactRating(id, data) {
    return this.restApi.request(
      'PUT',
      `/api/v5/sa-ra-impact-ratings/${id}`,
      data
    );
  }
  deleteImpactRating(id) {
    return this.restApi.request('DELETE', `/api/v5/sa-ra-impact-ratings/${id}`);
  }

  getRiskRating(tid) {
    return this.restApi.get(`/api/v5/sa-ra-risk-ratings`, {
      'templateId.equals': tid,
    });
  }
  addRiskRating(data) {
    return this.restApi.request('POST', '/api/v5/sa-ra-risk-ratings', data);
  }
  updateRiskRating(id, data) {
    return this.restApi.request(
      'PUT',
      `/api/v5/sa-ra-risk-ratings/${id}`,
      data
    );
  }
  deleteRiskRating(id) {
    return this.restApi.request('DELETE', `/api/v5/sa-ra-risk-ratings/${id}`);
  }

  getVulnerabilities(tid) {
    return this.restApi.get(`/api/v5/sa-ra-vulnerabilities`, {
      'templateId.equals': tid,
    });
  }
  addVulnerabilities(data) {
    return this.restApi.request('POST', '/api/v5/sa-ra-vulnerabilities', data);
  }
  updateVulnerabilities(id, data) {
    return this.restApi.request(
      'PUT',
      `/api/v5/sa-ra-vulnerabilities/${id}`,
      data
    );
  }
  deleteVulnerabilities(id) {
    return this.restApi.request(
      'DELETE',
      `/api/v5/sa-ra-vulnerabilities/${id}`
    );
  }

  getRiskVelocity(tid) {
    return this.restApi.get(`/api/v5/sa-ra-velocities`, {
      'templateId.equals': tid,
    });
  }
  addRiskVelocity(data) {
    return this.restApi.request('POST', '/api/v5/sa-ra-velocities', data);
  }
  updateRiskVelocity(id, data) {
    return this.restApi.request('PUT', `/api/v5/sa-ra-velocities/${id}`, data);
  }
  deleteRiskVelocity(id) {
    return this.restApi.request('DELETE', `/api/v5/sa-ra-velocities/${id}`);
  }

  addRaTemplateGroup(data) {
    return this.restApi.request(
      'POST',
      '/api/v5/multiple-sa-ra-template-groups',
      data
    );
  }
  getRaTemplateGroup(tid) {
    return this.restApi.get(
      '/api/v5/sa-ra-template-groups?page=0&size=2147483647',
      { 'raTemplateId.equals': tid }
    );
  }
}
